<template>
  <el-select
    v-model="categoryEquipmentModel"
    @change="categoryEquipmentChanged"
    autocomplete="new-password"
    :placeholder="$t('COMMON.CATEGORY_EQUIPMENTS')"
    :filterable="filterable"
    :multiple="multiple"
    :disabled="disabled"
    remote
    :remote-method="getcategoryEquipments"
    :loading="loading"
  >
    <el-option v-if="showAll" :value="null" :label="$t('COMMON.ALL_CATEGORY_EQUIPMENTS')">
    </el-option>
    <el-option v-if="allowNone" :value="null" :label="$t('COMMON.NONE')"> </el-option>
    <el-option
      v-for="categoryEquipment in categoryEquipments"
      :key="categoryEquipment.id"
      :value="categoryEquipment.id"
      :label="`${categoryEquipment.name}`"
    >
    </el-option>
  </el-select>
</template>

<script>
import { Option, Select } from "element-ui";

export default {
  name: "category-equipment-selector",

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
  },

  props: {
    disabled: {
      type: Boolean,
      default: false,
      description: "Disable the input",
    },
    showAll: {
      type: Boolean,
      default: true,
      description: "Show the option all",
    },
    allowNone: {
      type: Boolean,
      default: false,
      description: "Show the option none",
    },
    filterable: {
      type: Boolean,
      default: true,
      description: "Can filter",
    },
    categoryEquipment: {
      type: String,
      default: null,
      description: "Category Equipment id",
    },
    multiple: {
      type: Boolean,
      default: false,
      description: "Can filter",
    },

    filterOrganization: {
      type: String,
      default: null,
      description: "Organization id",
    },
  },

  data() {
    return {
      categoryEquipmentModel: this.categoryEquipment,
      categoryEquipments: {},
      loading: true,
    };
  },

  setup() {},

  created() {
    this.getcategoryEquipments(null, this.categoryEquipment);
  },

  methods: {
    async getcategoryEquipments(query = null, id = null) {
      try {
        this.loading = true;
        let params = {
          include: "organization",
          sort: "name",
          filter: {
            ...(query ? { search: encodeURIComponent(query) } : {}),
            ...(id ? { id: id } : {}),
          },
          page: {
            number: 1,
            size: 10,
          },
        };

        if (this.filterOrganization) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              organization: this.filterOrganization,
            },
          };
        }

        await this.$store.dispatch("categoryEquipments/list", params);
        const categoryEquipmentsArr = await this.$store.getters[
          "categoryEquipments/list"
        ];
        this.categoryEquipments = {};
        categoryEquipmentsArr.forEach((categoryEquipment) => {
          this.categoryEquipments[categoryEquipment.id] = categoryEquipment;
        });

        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.loading = false;
      }
    },

    categoryEquipmentChanged(categoryEquipment) {
      const categoryEquipmentSelected = Object.values(this.categoryEquipments).find(
        (item) => item.id === categoryEquipment
      );
      this.$emit(
        "categoryEquipmentChanged",
        categoryEquipment,
        categoryEquipmentSelected
      );
    },
  },

  watch: {
    categoryEquipment(categoryEquipment) {
      if (categoryEquipment) {
        this.categoryEquipmentModel = categoryEquipment;
      } else {
        this.categoryEquipmentModel = null;
      }
      this.getcategoryEquipments(null, this.categoryEquipment);
    },
    filterOrganization(filterOrganization) {
      this.getcategoryEquipments();
    },
  },
};
</script>
